import type { RadioButtonProps } from '@sravni/react-design-system/dist/types/components/RadioButton';

import { cards } from '@src/components/promo/hardcode';
import type { CardProps } from '@src/components/promo/PromoSection/Card';

export const PROMOTION_OPTIONS: RadioButtonProps['options'] = [
  {
    label: 'Акции',
    value: 'promotion',
  },
  {
    label: 'Промокоды',
    value: 'promoCodes',
  },
];

export enum PromotionCardsColSize {
  Mobile = 12,
  Desktop = 4,
}

const PROMOTION_PROMO_CODE_CARDS: Array<CardProps & { promoCode: string }> = [];

export const PROMOTION_OPTIONS_ARRAY = [
  {
    headline: 'Акции',
    cards,
  },
  {
    headline: 'Промокоды',
    cards: PROMOTION_PROMO_CODE_CARDS,
  },
];
